// Inicializando el state del reducer (Cada reducer tiene su propio state)
/*
    Estrutura base:
        1. Definir el state inicial con los atributos base de cada reducer (initialState).
        2. Definir la función en la cual se expone el switch para definir cada action.type para
           modificar el state.
*/

import {
    INIT_SESSION,
    LOGIN,
    LOGIN_ERROR,
    LOGOUT,
    ME
} from 'happ-redux/happ-types'

const initialState = {
    login_profile: null,
    login: false,
    error: false,
    error_msg: {},
    loading: false
}


export default function(state = initialState, action){
    switch(action.type){
        case INIT_SESSION:
            localStorage.removeItem('token');
            return {
                ...state,
                loading: true
            }
        case LOGIN:
            localStorage.setItem('token', action.payload.token);
            return {
                ...state,
                loading: false,
                login: true,
                login_profile: action.payload,
                error_msg: {}
            }   
        case LOGIN_ERROR:
            localStorage.removeItem('token');
            return {
                ...state,
                loading: false,
                login: false,
                error: true,
                error_msg: action.payload,
            }  
        case LOGOUT:
            localStorage.removeItem('token');
            return {
                ...state,
                loading: false,
                login: false,
                login_profile: null,
                error_msg: {},
                error: false
            }
        case ME:
            return {
                ...state,
                loading: false,
                login: true,
                error: false,
                login_profile: action.payload,
                error_msg: {},
            }

        default:
            return state
    }
}